var _defs, _g, _g2, _path, _g3, _path2, _path3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicakizi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "992.13pt",
    height: "935.43pt",
    viewBox: "0 0 992.13 935.43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m972 9h20.125v1h-20.125z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 915h2v20.43h-2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m982 915h1v20.43h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m972 925h20.125v1h-20.125z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 4.25
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m538.59 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2012.6 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m3486.6 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4960.6 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m6434.6 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7908.7 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9382.7 9439.4v-113.36"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m340.16 9269.3h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m340.16 6292.9h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m340.16 3316.5h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m340.16 340.16h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9467.7 9269.3h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9467.7 6292.9h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9467.7 3316.5h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9467.7 340.16h113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m538.59 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2012.6 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m3486.6 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4960.6 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m6434.6 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7908.7 255.12v-113.4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9382.7 255.12v-113.4"
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m99.219 9354.3v-198.44"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m198.44 9255.1h-198.44"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m99.219 9326.4c39.336 0 71.25-31.914 71.25-71.25 0-39.375-31.914-71.25-71.25-71.25-39.375 0-71.289 31.875-71.289 71.25 0 39.336 31.914 71.25 71.289 71.25"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9823 9354.3v-196.48"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9921.2 9256.1h-196.45",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9823 9326.6c38.945 0 70.547-31.602 70.547-70.547 0-38.984-31.602-70.547-70.547-70.547-38.984 0-70.586 31.562-70.586 70.547 0 38.945 31.602 70.547 70.586 70.547",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m99.219 198.44v-198.44",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m198.44 99.222h-198.44",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m99.219 170.47c39.336 0 71.25-31.914 71.25-71.25 0-39.375-31.914-71.25-71.25-71.25-39.375 0-71.289 31.875-71.289 71.25 0 39.336 31.914 71.25 71.289 71.25",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9823 198.44v-196.48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9921.2 100.2h-196.45",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m9823 170.78c38.945 0 70.547-31.641 70.547-70.586 0-38.984-31.602-70.547-70.547-70.547-38.984 0-70.586 31.562-70.586 70.547 0 38.945 31.602 70.586 70.586 70.586",
    stroke: "#000",
    strokeMiterlimit: 3.864,
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#ec1b24",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7908.7 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m8645.7 9070.8c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.477 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m6434.6 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7171.6 9070.8c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5s-42.539-19.023-42.539-42.5c0-23.477 19.062-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4960.6 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m5697.6 9070.8c23.477 0 42.539 19.062 42.539 42.539 0 23.477-19.062 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.477 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m3486.6 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4223.6 9070.8c23.516 0 42.539 19.062 42.539 42.539 0 23.477-19.023 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.477 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2012.6 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2749.6 9070.8c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.477 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m538.59 6292.9h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m1275.6 9070.8c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.477 0-42.539-19.023-42.539-42.5 0-23.477 19.062-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7908.7 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m8645.7 6094.5c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.477 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m6434.6 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7171.6 6094.5c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5s-42.539-19.023-42.539-42.5c0-23.477 19.062-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4960.6 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m5697.6 6094.5c23.477 0 42.539 19.062 42.539 42.539 0 23.477-19.062 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.477 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m3486.6 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4223.6 6094.5c23.516 0 42.539 19.062 42.539 42.539 0 23.477-19.023 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.477 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2012.6 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2749.6 6094.5c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.477 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m538.59 3316.5h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m1275.6 6094.5c23.477 0 42.5 19.062 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.477 0-42.539-19.023-42.539-42.5 0-23.477 19.062-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7908.7 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m8645.7 3118.1c23.477 0 42.5 19.023 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.516 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m6434.6 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m7171.6 3118.1c23.477 0 42.5 19.023 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5s-42.539-19.023-42.539-42.5c0-23.516 19.062-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4960.6 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m5697.6 3118.1c23.477 0 42.539 19.023 42.539 42.539 0 23.477-19.062 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.516 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m3486.6 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m4223.6 3118.1c23.516 0 42.539 19.023 42.539 42.539 0 23.477-19.023 42.5-42.539 42.5-23.477 0-42.5-19.023-42.5-42.5 0-23.516 19.023-42.539 42.5-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2012.6 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m2749.6 3118.1c23.477 0 42.5 19.023 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.516 0-42.539-19.023-42.539-42.5 0-23.516 19.023-42.539 42.539-42.539"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m538.59 340.16h1474v2976.4h-1474z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 935.43)",
    d: "m1275.6 3118.1c23.477 0 42.5 19.023 42.5 42.539 0 23.477-19.023 42.5-42.5 42.5-23.477 0-42.539-19.023-42.539-42.5 0-23.516 19.062-42.539 42.539-42.539"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.551 930.52h-0.98047l-0.17969-4.1875-0.79688 4.1875h-0.92969l1.0469-5.0117h1.4688l0.15234 3.5117 1.7109-3.5117h1.4883l-1.0508 5.0117h-0.94141l0.98828-4.1562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.652 928.58-0.28906-2.0156-1.2109 2.0156zm0.12891 0.83203h-1.9883l-0.60156 1.1094h-1.0586l2.8359-5.0117h1.1445l0.8125 5.0117h-0.97656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.543 930.52 1.0469-5.0117h1.0312l-0.44531 2.1289 2.3203-2.1289h1.3789l-2.2461 1.9648 1.6484 3.0469h-1.1641l-1.2383-2.3867-0.97266 0.85156-0.32422 1.5352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.766 928.58-0.29297-2.0156-1.207 2.0156zm0.125 0.83203h-1.9844l-0.60156 1.1094h-1.0586l2.832-5.0117h1.1445l0.8125 5.0117h-0.97656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.824 928.9 0.97656-0.050782c0.015625 0.3125 0.070313 0.52344 0.16406 0.63281 0.14844 0.17969 0.42578 0.26953 0.83203 0.26953 0.33984 0 0.58203-0.0625 0.73438-0.18359 0.14844-0.12109 0.22266-0.26562 0.22266-0.4375 0-0.14844-0.0625-0.27344-0.18359-0.375-0.085937-0.078125-0.32422-0.19922-0.71484-0.36719-0.38672-0.16797-0.67188-0.30859-0.84766-0.42188-0.17969-0.11328-0.32031-0.25781-0.42187-0.4375-0.10547-0.18359-0.15625-0.39062-0.15625-0.63281 0-0.42188 0.15234-0.77344 0.45703-1.0508 0.30469-0.27734 0.75-0.41797 1.3281-0.41797 0.58594 0 1.043 0.14062 1.3672 0.41406 0.32031 0.27734 0.5 0.64453 0.52734 1.1016l-0.98438 0.042969c-0.027344-0.23828-0.11328-0.42188-0.26172-0.55078-0.14844-0.125-0.36719-0.19141-0.65625-0.19141-0.28516 0-0.48828 0.054687-0.60938 0.15234-0.12109 0.10156-0.18359 0.22656-0.18359 0.37891 0 0.14453 0.054688 0.26172 0.16797 0.35547 0.11328 0.097656 0.35938 0.22656 0.74219 0.39453 0.57422 0.24609 0.94141 0.44922 1.1016 0.60547 0.23438 0.22656 0.35156 0.51953 0.35156 0.875 0 0.44531-0.17578 0.82031-0.52344 1.1328-0.35156 0.31641-0.83984 0.47266-1.4648 0.47266-0.42969 0-0.80078-0.074219-1.1172-0.21875s-0.53906-0.34375-0.66797-0.60156c-0.13281-0.25781-0.19141-0.55469-0.17969-0.89062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.824 927.64 0.18359-0.875c0.84375-0.36719 1.5-0.79688 1.9609-1.2891h0.59766l-1.0547 5.043h-0.98828l0.72656-3.4727c-0.20312 0.13281-0.44141 0.25391-0.71094 0.36328-0.26562 0.10938-0.50391 0.1875-0.71484 0.23047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.734 927.07-0.96094-0.14453c0.078124-0.46094 0.25781-0.82031 0.54297-1.0664 0.28125-0.24609 0.63672-0.37109 1.0625-0.37109 0.46875 0 0.83594 0.125 1.1016 0.37891s0.39844 0.57422 0.39844 0.96484c0 0.19922-0.039062 0.39453-0.12109 0.59375-0.082031 0.20312-0.21875 0.41016-0.40625 0.62891-0.13281 0.15625-0.35156 0.375-0.65625 0.66016-0.30859 0.28125-0.50781 0.47656-0.60547 0.57812-0.10156 0.10547-0.19531 0.21484-0.28906 0.33203h1.7383l-0.1875 0.89453h-3.043c0.03125-0.24609 0.10547-0.48047 0.21875-0.70313 0.10938-0.22266 0.25391-0.42969 0.42188-0.62109 0.16797-0.1875 0.47656-0.5 0.92578-0.92578 0.33594-0.32422 0.55078-0.53516 0.63672-0.63281 0.16016-0.17578 0.26953-0.33203 0.32812-0.46094 0.0625-0.12891 0.089844-0.24609 0.089844-0.35156 0-0.16797-0.046876-0.30469-0.14844-0.41016-0.097656-0.10547-0.22656-0.15625-0.37891-0.15625s-0.28906 0.058593-0.40625 0.17578c-0.11328 0.11719-0.20312 0.32812-0.26172 0.63672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.891 930.52h-0.97656l-0.18359-4.1875-0.79688 4.1875h-0.92969l1.0469-5.0117h1.4727l0.15234 3.5117 1.707-3.5117h1.4883l-1.0469 5.0117h-0.94141l0.98828-4.1562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.723 930.52h-0.97656l-0.18359-4.1875-0.79688 4.1875h-0.92969l1.0469-5.0117h1.4688l0.15625 3.5117 1.707-3.5117h1.4883l-1.0508 5.0117h-0.94141l0.99219-4.1562"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicakizi1);
export default __webpack_public_path__ + "static/media/bicakizi1.83b24d028ce5ac966e0b650cc9a81e84.svg";
export { ForwardRef as ReactComponent };